export const accountFields = {
  ID: 'id',
  TYPE: 'accountType',
  STATUS: 'accountStatus',
  LEGAL_ENTITY_NAME: 'legalEntityName',
};
